<template>
  <ChecklistItem
    title="4. Launch your site"
    description="Publish your site when you are ready"
    :is-done="false"
    :editing="false"
  >
    <template #pitch>
      <iText font-size="standard">
        Coming soon...
      </iText>
    </template>
  </ChecklistItem>
</template>

<script>
import ChecklistItem from "@/components/onboarding/ChecklistItem.vue";
export default { name: "LaunchSiteChecklist", components: { ChecklistItem } };
</script>

<style scoped lang="scss">
</style>
